module.exports = __webpack_public_path__ + "img/bgd_border_01.3cd65a3.gif";